const genericDropdownActions = [
  {
    action: 'rename',
    label: 'Rename',
  },
  {
    action: 'delete',
    label: 'Delete',
    isHighlighted: true,
  },
];

export const genericEditableMediaList = [
  {
    extension: 'jpg',
    id: '1',
    name: 'Maldives is so pretty',
    thumbUrl:
      'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=765&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '2 hours ago',
    dropdownActions: genericDropdownActions,
  },
  {
    extension: 'jpg',
    id: '2',
    name: 'Yummy!',
    thumbUrl:
      'https://images.unsplash.com/photo-1661791839093-0b8baf8616ab?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1073&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '5 hours ago',
    dropdownActions: genericDropdownActions,
  },
  {
    extension: 'jpg',
    id: '3',
    name: 'Just a temple',
    thumbUrl:
      'https://images.unsplash.com/photo-1661638563864-7ade2d3ec500?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '14 hours ago',
    dropdownActions: genericDropdownActions,
  },
  {
    extension: 'jpg',
    id: '4',
    name: 'Pretty tiger',
    thumbUrl:
      'https://images.unsplash.com/photo-1661769212734-67877c79deff?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1331&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '1 day ago',
    dropdownActions: genericDropdownActions,
  },
  {
    extension: 'jpg',
    id: '5',
    name: 'Garden',
    thumbUrl:
      'https://images.unsplash.com/photo-1661753186882-e48ec0103a42?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '1 day ago',
    dropdownActions: genericDropdownActions,
  },
  {
    extension: 'jpg',
    id: '6',
    name: 'A lovely baby',
    thumbUrl:
      'https://images.unsplash.com/photo-1661664489852-07a9c803b446?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '5 days ago',
    dropdownActions: genericDropdownActions,
  },
  {
    extension: 'jpg',
    id: '7',
    name: 'Planet surface',
    thumbUrl:
      'https://images.unsplash.com/photo-1661655885711-ca28a47651b5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '1 week ago',
    dropdownActions: genericDropdownActions,
  },
  {
    extension: 'jpg',
    id: '8',
    name: 'In a crop',
    thumbUrl:
      'https://images.unsplash.com/photo-1661532117027-9d21a75c1fbc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '1 month ago',
    dropdownActions: genericDropdownActions,
  },
  {
    extension: 'jpg',
    id: '9',
    name: 'What a nice view',
    thumbUrl:
      'https://images.unsplash.com/photo-1661758239207-0410635ad099?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '1 month ago',
    dropdownActions: genericDropdownActions,
  },
  {
    extension: 'jpg',
    id: '10',
    name: 'Sunflowers',
    thumbUrl:
      'https://images.unsplash.com/photo-1661861622628-e033af571c0f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '2 months ago',
    dropdownActions: genericDropdownActions,
  },
  {
    extension: 'jpg',
    id: '11',
    name: 'Golden model',
    thumbUrl:
      'https://images.unsplash.com/photo-1661868888769-a68f55ae00b5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '3 months ago',
    dropdownActions: genericDropdownActions,
  },
  {
    extension: 'jpg',
    id: '12',
    name: 'Cozy bed',
    thumbUrl:
      'https://images.unsplash.com/photo-1661796428175-55423b19409f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=688&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '1 year ago',
    dropdownActions: genericDropdownActions,
  },
  {
    extension: 'jpg',
    id: '13',
    name: 'Flowers',
    thumbUrl:
      'https://images.unsplash.com/photo-1748280443540-4358f64cf1b2?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '1 year ago',
    dropdownActions: genericDropdownActions,
  },
  {
    extension: 'jpg',
    id: '14',
    name: 'This is a long name for a media',
    thumbUrl:
      'https://images.unsplash.com/photo-1747570171404-3d2ae1e87995?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '1 year ago',
    dropdownActions: genericDropdownActions,
  },
];

export const genericVideoList = [
  {
    duration: 260000,
    id: '1',
    name: 'Video 1',
    thumbUrl:
      'https://images.unsplash.com/photo-1661791839093-0b8baf8616ab?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1073&q=80',
    type: 'Video',
    uploadingText: 'uploading',
    updateDate: '20.811 views',
  },
  {
    duration: 15000,
    id: '2',
    name: 'Video 2',
    thumbUrl:
      'https://images.unsplash.com/photo-1661791839093-0b8baf8616ab?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1073&q=80',
    type: 'Video',
    uploadingText: 'uploading',
    updateDate: '3.720.340 views',
  },
  {
    duration: 33000,
    id: '3',
    name: 'Video 3',
    thumbUrl:
      'https://images.unsplash.com/photo-1661791839093-0b8baf8616ab?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1073&q=80',
    type: 'Video',
    uploadingText: 'uploading',
    updateDate: '820.002 views',
  },
  {
    duration: 146000,
    id: '4',
    name: 'Video 4',
    thumbUrl:
      'https://images.unsplash.com/photo-1661791839093-0b8baf8616ab?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1073&q=80',
    type: 'Video',
    uploadingText: 'uploading',
    updateDate: '4.187 views',
  },
  {
    duration: 2600000,
    id: '5',
    name: 'Video 5',
    thumbUrl:
      'https://images.unsplash.com/photo-1661791839093-0b8baf8616ab?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1073&q=80',
    type: 'Video',
    uploadingText: 'uploading',
    updateDate: '500 views',
  },
];

export const genericMediaList = [
  {
    extension: 'jpg',
    id: '1',
    name: 'Maldives is so pretty',
    thumbUrl:
      'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=765&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '2 hours ago',
  },
  {
    extension: 'jpg',
    id: '2',
    name: 'Yummy!',
    thumbUrl:
      'https://images.unsplash.com/photo-1661791839093-0b8baf8616ab?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1073&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '5 hours ago',
  },
  {
    extension: 'jpg',
    id: '3',
    name: 'Just a temple',
    thumbUrl:
      'https://images.unsplash.com/photo-1661638563864-7ade2d3ec500?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '14 hours ago',
  },
  {
    extension: 'jpg',
    id: '4',
    name: 'Pretty tiger',
    thumbUrl:
      'https://images.unsplash.com/photo-1661769212734-67877c79deff?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1331&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '1 day ago',
  },
  {
    extension: 'jpg',
    id: '5',
    name: 'Garden',
    thumbUrl:
      'https://images.unsplash.com/photo-1661753186882-e48ec0103a42?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
    type: 'Image',
    uploadingText: 'uploading',
    updateDate: '1 day ago',
  },
];
